// tslint:disable:jsx-no-lambda
import React, { PureComponent } from 'react'
import { TranslationFunction } from 'react-i18next'

import { i18nKeys } from '../../../app.i18n'
import { Button, isPresent } from '../../../shared'
import { AssessmentValue } from '../../shared/review'

import './employee-emoji-rating.scss'

type OwnProps = {
  rating: AssessmentValue
  disabled: boolean
  translate: TranslationFunction
  onChange?(value: number): void
}

type Props = OwnProps

class EmployeeEmojiRating extends PureComponent<Props> {
  render() {
    const { disabled, translate } = this.props

    const t = translate

    return (
      <div className="emoji-rating">
        <Button
          value={AssessmentValue.NotThatGood}
          className={this.setClassName(AssessmentValue.NotThatGood)}
          onClick={this.handleChange(AssessmentValue.NotThatGood)}
          disabled={disabled}
        >
          {t(i18nKeys.frontFace.reviews.ratingIcon.notThatGood)}
        </Button>
        <Button
          value={AssessmentValue.AtTheEdge}
          className={this.setClassName(AssessmentValue.AtTheEdge)}
          onClick={this.handleChange(AssessmentValue.AtTheEdge)}
          disabled={disabled}
        >
          {t(i18nKeys.frontFace.reviews.ratingIcon.atTheEdge)}
        </Button>
        <Button
          value={AssessmentValue.Successful}
          className={this.setClassName(AssessmentValue.Successful)}
          onClick={this.handleChange(AssessmentValue.Successful)}
          disabled={disabled}
        >
          {t(i18nKeys.frontFace.reviews.ratingIcon.successful)}
        </Button>
        <Button
          value={AssessmentValue.ExceptionallyGood}
          className={this.setClassName(AssessmentValue.ExceptionallyGood)}
          onClick={this.handleChange(AssessmentValue.ExceptionallyGood)}
          disabled={disabled}
        >
          {t(i18nKeys.frontFace.reviews.ratingIcon.exceptionallyGood)}
        </Button>
      </div>
    )
  }
  private handleChange = (value: AssessmentValue) => () => {
    const { onChange } = this.props
    isPresent(onChange) && onChange(value)
  }

  private setClassName(value: number) {
    const { rating } = this.props

    return rating === value
      ? 'emoji-rating__button bp3-minimal emoji-rating__item--selected'
      : 'emoji-rating__button bp3-minimal emoji-rating__item'
  }
}

export default EmployeeEmojiRating



// WEBPACK FOOTER //
// ./src/app/front-face/shared/employee-emoji-rating/employee-emoji-rating.tsx